export default {"src":"/_next/static/media/GS-Logo-Full.71463ed7.svg","height":47,"width":109,"blurWidth":0,"blurHeight":0};